import React, {useState} from 'react';
import {Link} from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import "./Login.css";

function LoginPage(props) {

  const currentUser = JSON.parse(window.localStorage.getItem('user'));

  // Keep track of user data entered into form
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const onLogin = (e) => {
    props.handleLogin(e, email, password)    // use parent function
  }

  // let navigate = useNavigate();
  // const goToAdminPortal = () => {
  //   navigate(`/admin/register`);
  // }

  if (currentUser === undefined || currentUser === null) {
    return (
      <div className='signInContainer'>
      <form className="loginForm" onSubmit={onLogin}>
        <h1>Login to your Existing Account Here</h1>
        <br></br>
        <br></br>
        <input
          className="inputField"
          type="email"
          placeholder="Enter your email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        ></input>
        <br></br>
        <input
          className="inputField"
          type="password"
          placeholder="Enter your password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        ></input>
        <button className="loginButton" type="submit">Login</button>
        <p className="userMessage" >Forgot your password? Reset it <Link to="/resetPassword">here</Link>.</p>
      </form>
    </div>
    );
  }

  return (
    <>
        <p className="userMessage">{`You are currently logged in as: ${currentUser.email}`}</p>
        <button className="loginButton" onClick={props.handleLogout}>Logout</button>
    </> 
  );
}

export default LoginPage;

